import { render, staticRenderFns } from "./PrescriptionResultPage.vue?vue&type=template&id=71caf901&scoped=true"
import script from "./PrescriptionResultPage.vue?vue&type=script&lang=js"
export * from "./PrescriptionResultPage.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionResultPage.vue?vue&type=style&index=0&id=71caf901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71caf901",
  null
  
)

export default component.exports